<template>
    <div>
        <h1>Testpage</h1>
        <p>id: {{id}}</p>
        <p>slug: {{slug}}</p>
    </div>
</template>
<script>
export default {
    name: 'Testpage',
    data() {
        return {
            id: this.$route.params.id,
            slug: this.$route.params.slug
        }
    },

}
</script>
<style scoped>
</style>
